import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateCarForm } from "web_myplann/Portfolio/Pages/CarCreate/CreateCarForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddCarPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddCar.title)}>
			<CreateCarForm />
		</PortfolioAddLayout>
	);
};
